'use client'

import { Split } from '@/screens/Split'

const SplitPageContent = () => {
	return (
		<>
			<Split />
		</>
	)
}

export function SplitClient() {
	return <SplitPageContent />
}
